import React, { useEffect, useMemo, useState } from "react";
import "./ResumePage.css";

import CertImg1 from "./assets/Certificate_img_1.png";
import CertImg2 from "./assets/certificates/adobe_certificate.jpg";
import CertImg3 from "./assets/certificates/certificate_img_3.jpeg";
import CertImg4 from "./assets/certificates/certificate_img_4.jpeg";
import CertImg5 from "./assets/certificates/certificate_img_5.jpeg";
import CertImg6 from "./assets/certificates/Claude_101.png";
import CertImg7 from "./assets/certificates/Claude_Action.png";
import CertImg9 from "./assets/certificates/Anthropic_API.png";
import CertImg10 from "./assets/certificates/LangChain_Essentials.png";
import CertImg11 from "./assets/certificates/LangGraph_Essentials.png";
import CertImg12 from "./assets/certificates/Deep_Agents.png";

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="4.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M12 2.5v2.2M12 19.3v2.2M4.93 4.93l1.56 1.56M17.51 17.51l1.56 1.56M2.5 12h2.2M19.3 12h2.2M4.93 19.07l1.56-1.56M17.51 6.49l1.56-1.56"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M19 14.5A8.5 8.5 0 0 1 9.5 5a8.7 8.7 0 1 0 9.5 9.5Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ShareIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M14 4h6v6M10 14 20 4M20 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ExternalIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M14 4h6v6M10 14 20 4M20 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const EXPERIENCE = [
  {
    role: "UI Designer & Web Developer",
    company: "NukePC",
    location: "Chennai, Tamil Nadu",
    timeline: "December 2025 - January 2026",
    bullets: [
      "Led end-to-end design of the NukePC mobile app as the sole designer — from concept to production — improving navigation, user flows, and overall experience for 10,000+ users.",
      "Collaborated closely with the development team to translate design intent into production-ready UI with minimal rework.",
      "Developed the A2D Media Group website end-to-end using React and Tailwind CSS, handling everything from component architecture to responsive layout and final deployment.",
      "Designed a CRM interface for managing sales pipelines, customer data, and custom workflows, focused on making complex data easy to scan and act on.",
    ],
  },
  {
    role: "Frontend Developer",
    company: "RMKCET Website Revamp (rmkcet.ac.in)",
    location: "Chennai, Tamil Nadu",
    timeline: "August 2024 - May 2025",
    bullets: [
      "Rebuilt and redesigned key pages of the institutional website (rmkcet.ac.in), serving 3,500+ students and faculty across departments.",
      "Redesigned the homepage with improved visual hierarchy, typography, and UI consistency to better represent the institution.",
      "Rebuilt page layouts using Flexbox and Grid for fully responsive behavior across devices and screen sizes.",
      "Maintained and updated institutional content pages to keep information accurate and accessible.",
    ],
  },
  {
    role: "Winner & Developer",
    company: "MSME Idea Hackathon",
    location: "Chennai, Tamil Nadu",
    timeline: "December 2025 - Present",
    bullets: [
      "Designed and developed a Hospital Bed Management System connecting hospitals, pharmacies, ambulances, and patients in one workflow.",
      "Created responsive booking and emergency access interfaces for patient usability.",
      "Designed product flows in Figma and implemented production UI using React and Tailwind CSS.",
      "Delivered the prototype that won the MSME Innovation Hackathon.",
    ],
  },
];

const PROJECTS = [
  {
    title: "Ceilang",
    stack: "Figma, Concept Design, Mobile",
    link: "#/project/ceilang",
    bullets: [
      "Concept mobile experience designed to make language learning feel more conversational and emotionally safe.",
      "Focused on fluency-building through continuity, adaptive immersion, and supportive AI-led interaction design.",
    ],
  },
  {
    title: "Equora",
    stack: "React.js, PostgreSQL, Gemini API, Recharts, Tailwind CSS",
    link: "#/project/equora",
    bullets: [
      "AI-based stock portfolio intelligence dashboard designed for users who find financial tools intimidating.",
      "Built with a focus on clarity, portfolio tracking, plain-English insights, and responsive data visualization.",
    ],
  },
  {
    title: "Returns Radar",
    stack: "React.js, Firebase, Gemini API",
    bullets: [
      "Web dashboard designed to help sellers analyze product return patterns and insights.",
      "Developed using React.js with a focus on responsive UI and actionable return analytics.",
    ],
  },
  {
    title: "Medshift 360",
    stack: "React, TypeScript, ShadCN, Tailwind CSS",
    link: "#/project/medshift-360",
    bullets: [
      "Healthcare web application for bed availability, ambulance booking, and patient health management.",
      "Designed and built high-priority medical workflows with strong emphasis on clarity and speed under pressure.",
    ],
  },
];

const SKILL_GROUPS = [
  {
    title: "Frontend",
    items: [
      "HTML",
      "CSS",
      "JavaScript",
      "React.js",
      "Next.js",
      "Tailwind CSS",
      "Bootstrap",
      "jQuery",
      "GSAP",
      "Web Development",
      "Responsive Design",
      "API Integration",
    ],
  },
  {
    title: "Backend",
    items: [
      "Node.js",
      "Express.js",
      "Firebase",
      "Supabase",
      "MySQL",
      "PostgreSQL",
    ],
  },
  {
    title: "Design",
    items: [
      "Figma",
      "Adobe Illustrator",
      "Blender",
      "UX Design",
      "UI Design",
      "Interaction Design",
      "Wireframing",
      "Prototyping",
      "Balsamiq",
      "Design Systems",
      "Typography",
      "Color Theory",
      "Web Design",
    ],
  },
  {
    title: "Core Strengths",
    items: [
      "Leadership & Communication",
      "Attention to Detail",
      "Product Design Thinking",
      "Problem Solving",
      "Passionate Learner",
    ],
  },
];

const EDUCATION = [
  {
    school: "RMK College of Engineering and Technology",
    detail: "Bachelor of Engineering in Computer Science and Engineering",
    meta: "7.45 CGPA",
    location: "Thiruvallur, Tamil Nadu",
    timeline: "Oct 2022 - May 2026",
  },
  {
    school: "Kola Perumal Chetty Vaishnav Sr. Sec School",
    detail: "Class XII (HSC) - CBSE",
    meta: "73.83 %",
    location: "Chennai, Tamil Nadu",
    timeline: "Apr 2021 - Jun 2022",
  },
  {
    school: "Kola Perumal Chetty Vaishnav Sr. Sec School",
    detail: "Class X (HSC) - CBSE",
    meta: "81.50 %",
    location: "Chennai, Tamil Nadu",
    timeline: "Apr 2019 - Mar 2020",
  },
];

const CERTIFICATES = [
  {
    title: "SAP Certificate, SAP Generative AI",
    image: CertImg1,
  },
  {
    title: "Adobe Hackathon",
    image: CertImg2,
  },
  {
    title: "VIT Build With AI Hackathon",
    image: CertImg3,
  },
  {
    title: "Walmart Sparkathon",
    image: CertImg4,
  },
  {
    title: "MSME India Idea Hackathon",
    image: CertImg5,
  },
  {
    title: "Claude Code 101",
    image: CertImg6,
  },
  {
    title: "Claude Code in Action",
    image: CertImg7,
  },
  {
    title: "Claude with Anthropic API",
    image: CertImg9,
  },
  {
    title: "LangChain Essentials - TypeScript",
    image: CertImg10,
  },
  {
    title: "LangGraph Essentials - TypeScript",
    image: CertImg11,
  },
  {
    title: "Deep Agents with LangGraph",
    image: CertImg12,
  },
];

function ResumeRow({ label, children }) {
  return (
    <section className="resume-row">
      <div className="resume-row__label">{label}</div>
      <div className="resume-row__content">{children}</div>
    </section>
  );
}

function ExportThemeModal({
  isOpen,
  selectedTheme,
  onChange,
  onClose,
  onExport,
}) {
  if (!isOpen) return null;

  return (
    <div className="resume-export-modal" onClick={onClose}>
      <div
        className="resume-export-modal__dialog"
        onClick={(event) => event.stopPropagation()}
      >
        <h3>Export Resume as PDF</h3>
        <p>Choose the theme you want for the PDF.</p>

        <div className="resume-export-options">
          <label className="resume-export-option">
            <input
              type="radio"
              name="pdf-theme"
              value="current"
              checked={selectedTheme === "current"}
              onChange={() => onChange("current")}
            />
            <span>Current Theme</span>
          </label>

          <label className="resume-export-option">
            <input
              type="radio"
              name="pdf-theme"
              value="light"
              checked={selectedTheme === "light"}
              onChange={() => onChange("light")}
            />
            <span>Light Theme</span>
          </label>

          <label className="resume-export-option">
            <input
              type="radio"
              name="pdf-theme"
              value="dark"
              checked={selectedTheme === "dark"}
              onChange={() => onChange("dark")}
            />
            <span>Dark Theme</span>
          </label>
        </div>

        <div className="resume-export-modal__actions">
          <button
            type="button"
            className="resume-export-modal__button is-secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="resume-export-modal__button"
            onClick={onExport}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}

export default function ResumePage() {
  const [theme, setTheme] = useState(() => {
    return window.localStorage.getItem("resume-theme") || "dark";
  });
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [pdfThemeChoice, setPdfThemeChoice] = useState("current");

  useEffect(() => {
    window.localStorage.setItem("resume-theme", theme);
  }, [theme]);

  useEffect(() => {
    const handleAfterPrint = () => {
      const restoreTheme = window.sessionStorage.getItem("resume-restore-theme");
      if (restoreTheme) {
        setTheme(restoreTheme);
        window.sessionStorage.removeItem("resume-restore-theme");
      }
    };

    window.addEventListener("afterprint", handleAfterPrint);
    return () => window.removeEventListener("afterprint", handleAfterPrint);
  }, []);

  const isDark = theme === "dark";

  const shareLabel = useMemo(() => "Export PDF", []);

  const handleThemeToggle = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const handleOpenExport = () => {
    setPdfThemeChoice("current");
    setIsExportModalOpen(true);
  };

  const handleExportPdf = () => {
    const nextTheme = pdfThemeChoice === "current" ? theme : pdfThemeChoice;

    window.sessionStorage.setItem("resume-restore-theme", theme);
    setTheme(nextTheme);
    setIsExportModalOpen(false);

    window.setTimeout(() => {
      window.print();
    }, 180);
  };

  return (
    <>
      <main className={`resume-page ${isDark ? "is-dark" : "is-light"}`}>
        <div className="resume-shell">
          <div className="resume-toolbar no-print">
            <button
              type="button"
              className="resume-toolbar__button"
              onClick={handleOpenExport}
            >
              <ShareIcon />
              <span>{shareLabel}</span>
            </button>

            <button
              type="button"
              className="resume-toolbar__button resume-toolbar__button--theme"
              onClick={handleThemeToggle}
              aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
            >
              <span className={`resume-theme-icon ${!isDark ? "is-active" : ""}`}>
                <SunIcon />
              </span>
              <span className={`resume-theme-icon ${isDark ? "is-active" : ""}`}>
                <MoonIcon />
              </span>
            </button>
          </div>

          <header className="resume-header">
            <div className="resume-header__brand">
              <span className="resume-header__bar" />
              <div>
                <h1>Ragav Krishna</h1>
                <p>UI/UX Designer • Front-End Developer</p>
              </div>
            </div>
          </header>

          <ResumeRow label="About Me">
            <div className="resume-paragraphs">
              <p>
                Computer Science Engineering fresher with hands-on experience designing and building user-centered web and mobile interfaces. Passionate about bridging design and development, from early wireframes and prototypes to production-ready applications.
              </p>
              <p>
               I work across both UI/UX and fullstack development, with a strong eye for visual detail and a product-first mindset. I care about how things look, how they feel, and how they work under the hood. Whether it's crafting user flows in Figma or shipping responsive interfaces in React, I'm most at home solving real problems with clean, thoughtful execution.
              </p>
              <p>
                I've worked on real products used by real people, across mobile apps, web platforms, and internal tools, and I bring that same seriousness to everything I build. Always curious, always learning, always building.
              </p>
            </div>
          </ResumeRow>

          <ResumeRow label="Experience">
            <div className="resume-stack">
              {EXPERIENCE.map((item) => (
                <article className="resume-entry" key={`${item.role}-${item.company}`}>
                  <div className="resume-entry__head">
                    <div>
                      <h3>{item.role}</h3>
                      <h4>{item.company}</h4>
                    </div>
                    <span className="resume-entry__time">{item.timeline}</span>
                  </div>

                  <div className="resume-entry__meta">{item.location}</div>

                  <ul className="resume-bullets">
                    {item.bullets.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                </article>
              ))}
            </div>
          </ResumeRow>

          <ResumeRow label="Projects">
            <div className="resume-stack">
              {PROJECTS.map((project) => (
                <article className="resume-project" key={project.title}>
                  <div className="resume-project__head">
                    <div>
                      <h3>{project.title}</h3>
                      <p>{project.stack}</p>
                    </div>

                    {project.link ? (
                      <a href={project.link} className="resume-project__link">
                        <span>View</span>
                        <ExternalIcon />
                      </a>
                    ) : null}
                  </div>

                  <ul className="resume-bullets">
                    {project.bullets.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                </article>
              ))}
            </div>
          </ResumeRow>

          <ResumeRow label="Certifications">
            <div className="resume-cert-inline">
              {CERTIFICATES.map((certificate) => (
                <a
                  key={certificate.title}
                  href={certificate.image}
                  target="_blank"
                  rel="noreferrer"
                  className="resume-cert-inline__link"
                >
                  {certificate.title}
                </a>
              ))}
            </div>
          </ResumeRow>

          <ResumeRow label="Skills">
            <div className="resume-skill-groups">
              {SKILL_GROUPS.map((group) => (
                <section className="resume-skill-group" key={group.title}>
                  <h3>{group.title}</h3>

                  <div className="resume-skill-grid-4">
                    {group.items.map((item) => (
                      <div className="resume-skill-grid-4__item" key={item}>
                        {item}
                      </div>
                    ))}
                  </div>
                </section>
              ))}
            </div>
          </ResumeRow>

          <ResumeRow label="Education">
            <div className="resume-stack">
              {EDUCATION.map((item) => (
                <article
                  className="resume-entry resume-entry--education"
                  key={`${item.school}-${item.timeline}`}
                >
                  <div className="resume-entry__head">
                    <div>
                      <h3>
                        {item.school} <span>{item.meta}</span>
                      </h3>
                      <h4>{item.detail}</h4>
                    </div>
                    <span className="resume-entry__time">{item.timeline}</span>
                  </div>

                  <div className="resume-entry__meta">{item.location}</div>
                </article>
              ))}
            </div>
          </ResumeRow>

          <footer className="resume-footer">
            <div className="resume-footer__contact">
              <span className="resume-footer__bar" />
              <div>
                <h2>Contacts</h2>
                <p>
                  <a href="mailto:ragavkrishna4535@gmail.com">
                    ragavkrishna4535@gmail.com
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.linkedin.com/in/ragav-krishna-610153287"
                    target="_blank"
                    rel="noreferrer"
                  >
                    linkedin.com/in/ragav-krishna
                  </a>
                </p>
                <p>
                  <a href="https://www.ragav.me" target="_blank" rel="noreferrer">
                    www.ragav.me
                  </a>
                </p>
              </div>
            </div>
          </footer>
        </div>
      </main>

      <ExportThemeModal
        isOpen={isExportModalOpen}
        selectedTheme={pdfThemeChoice}
        onChange={setPdfThemeChoice}
        onClose={() => setIsExportModalOpen(false)}
        onExport={handleExportPdf}
      />
    </>
  );
}
